import { useState } from "react";
import { Gift, Sparkles, Trophy } from "lucide-react";
import { toast } from "sonner";

const DYNAMICS = {
  trivia: { title: "Trivia relámpago", text: "Responde antes de que vuelva el programa y suma puntos Believer.", icon: Sparkles },
  reto: { title: "Reto de regreso", text: "Elige el reto de Anto o Bella para activar una recompensa del sponsor.", icon: Trophy },
  votacion: { title: "Votación en vivo", text: "Tu voto decide qué momento quieres ver al volver de la pausa.", icon: Sparkles },
  recompensa: { title: "Recompensa sorpresa", text: "Activa la recompensa disponible durante este corte comercial.", icon: Gift },
};

export const CommercialDynamics = ({ dynamic = "trivia" }) => {
  const [joined, setJoined] = useState(false);
  const item = DYNAMICS[dynamic] || DYNAMICS.trivia;
  const Icon = item.icon;
  const join = () => {
    setJoined(true);
    toast.success("Dinámica activada", { description: "Esta interacción funciona como prototipo de segunda pantalla." });
  };

  return (
    <section data-testid="commercial-dynamics" className="rounded-[1.5rem] bg-gold p-6 text-ink sm:p-8">
      <div className="flex flex-wrap items-start justify-between gap-5"><div><span className="font-mono text-[10px] uppercase tracking-widest text-ink/60">Dinámica de comerciales</span><h2 className="mt-3 font-display text-3xl font-extrabold">{item.title}</h2><p className="mt-3 max-w-xl text-sm leading-relaxed text-ink/75">{item.text}</p></div><Icon className="h-9 w-9" aria-hidden="true" /></div>
      <button type="button" data-testid="commercial-dynamic-participate" onClick={join} disabled={joined} className="mt-6 inline-flex rounded-full bg-ink px-5 py-3 text-sm font-semibold text-cream transition-[background-color,transform] hover:-translate-y-0.5 hover:bg-coral disabled:cursor-default disabled:bg-ink/55">
        {joined ? "Participación activada" : "Participar ahora"}
      </button>
    </section>
  );
};